<template>
  <div>

   <!-- Top Info Grid -->
    <section class="top-info py-2">
      <b-container>
        <b-row class="text-center align-items-center">
          <b-col md="4" class="info-item">
            <strong>Our Office</strong><br />
            <small>laaga rd 4 elepe ikorodu, Lagos stste</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Email Us</strong><br />
            <small>olaleresomod24@gmail.com</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Contact Us</strong><br />
            <small>+234 800 123 4567</small>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- NAVBAR -->
    <b-navbar toggleable="lg" type="dark" variant="dark" class="bg-dark">
      <b-navbar-brand to="/">JEWELUX</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/shop">Shop</b-nav-item>
          <b-nav-item to="/about">About Us</b-nav-item>
          <b-nav-item to="/partners">Partners</b-nav-item>
          <b-nav-item to="/contact">contacts</b-nav-item>
          <b-nav-item to="/cart">oart</b-nav-item>
        </b-navbar-nav>


      </b-collapse>
    </b-navbar>

    <!-- PRODUCT DETAIL -->
    <b-container class="mt-5">

      <b-row>

        <!-- MAIN IMAGE -->
        <b-col md="6">

          <img src="../assets/earrings.jpg" class="img-fluid main-img">

        </b-col>



        <!-- PRODUCT INFO -->
        <b-col md="6">

          <h2 class="mb-3">Luxury Earrings</h2>

          <h4 class="text-primary mb-3">$450</h4>

          <p class="text-muted">
            Premium diamond ring designed for elegance and durability.
            Perfect for weddings and luxury fashion.
          </p>



          <!-- QUANTITY -->
          <div class="d-flex align-items-center mb-3">

            <label class="mr-3">Quantity:</label>

            <b-form-input
              type="number"
              v-model="quantity"
              min="1"
              style="width:100px">
            </b-form-input>

          </div>



          <!-- ADD TO CART -->
          <b-button variant="dark" size="lg" @click="addToCart">
            Add to Cart
          </b-button>



          <!-- PRODUCT META -->
          <div class="mt-4">

            <p><strong>Category:</strong> Rings</p>

            <p><strong>Availability:</strong> In Stock</p>

            <p><strong>Shipping:</strong> Free Delivery</p>

          </div>

        </b-col>

      </b-row>



      <!-- TABS -->
      <b-tabs class="mt-5">

        <b-tab title="Description" active>

          <p class="mt-3">
            This Earring is crafted from premium gold and high-quality
            diamond with excellent finishing and durability.
          </p>

        </b-tab>


        <b-tab title="Specifications">

          <ul class="mt-3">
            <li>Material: Gold</li>
            <li>Stone: Diamond</li>
            <li>Weight: 5g</li>
            <li>Size: Adjustable</li>
          </ul>

        </b-tab>


        <b-tab title="Reviews">

          <p class="mt-3">No reviews yet.</p>

        </b-tab>

      </b-tabs>


    </b-container>



    <!-- SIMILAR PRODUCTS -->
    <b-container class="mt-5">

      <h3 class="text-center mb-4">Similar Products</h3>

      <b-row>

        <!-- PRODUCT 1 -->
        <b-col md="4">

          <b-card class="text-center mb-4">

            <img src="../assets/goldnec.jpg" class="img-fluid similar-img">

            <h5 class="mt-3">Gold Necklace</h5>

            <p>$650</p>

          </b-card>

        </b-col>



        <!-- PRODUCT 2 -->
        <b-col md="4">

          <b-card class="text-center mb-4">

            <img src="../assets/silver.jpg" class="img-fluid similar-img">

            <h5 class="mt-3">Silver Bracelet</h5>

            <p>$300</p>

          </b-card>

        </b-col>



        <!-- PRODUCT 3 -->
        <b-col md="4">

          <b-card class="text-center mb-4">

            <img src="../assets/diamond.jpg" class="img-fluid similar-img">

            <h5 class="mt-3">Luxury Earrings</h5>

            <p>$450</p>

          </b-card>

        </b-col>


      </b-row>

    </b-container>



   <!-- Modern Footer -->
    <b-container fluid class="bg-dark text-white pt-5 pb-3">
      <b-row class="text-center text-md-left">

        <!-- Brand / Logo -->
        <b-col md="3" class="mb-4">
          <h4 class="text-gold font-weight-bold">JEWELUX</h4>
          <p class="small">Luxury handcrafted jewelry for every occasion.</p>
        </b-col>

        <!-- Quick Links -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Quick Links</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white">Home</a></li>
            <li><a href="#" class="text-white">Shop</a></li>
            <li><a href="#" class="text-white">About</a></li>
            <li><a href="#" class="text-white">Contact</a></li>
          </ul>
        </b-col>

        <!-- Social Media -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Follow Us</h5>
          <div>
            <b-icon icon="facebook" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="instagram" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="twitter" font-scale="1.5" class="mr-2 text-white"></b-icon>
          </div>
        </b-col>

        <!-- Newsletter -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Newsletter</h5>
          <b-form @submit.prevent="subscribe">
            <b-input-group size="sm">
              <b-form-input v-model="email" type="email" placeholder="Your email" required></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="gold">Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col class="text-center small">
          &copy; 2026 JEWELUX. All rights reserved.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>



<script>
export default {

  name: "DetailPage",

  data() {

    return {

      quantity: 1

    }

  },

  methods: {

    addToCart() {

      let product = {

        name: "Luxury Diamond Ring",
        price: 450,
        image: "../assets/person_1.jpg",
        quantity: this.quantity

      }

      let cart = JSON.parse(localStorage.getItem("cart")) || []

      cart.push(product)

      localStorage.setItem("cart", JSON.stringify(cart))

      alert("Product added to cart")

    }

  }

}
</script>



<style>

.main-img {

  border-radius: 10px;
  border: 1px solid #ddd;

}

.similar-img {

  border-radius: 8px;
  border: 1px solid #ddd;

}

/* Footer Styling */
.text-gold {
  color: #bfa14b;
}

</style>
